import React, { useCallback, useEffect } from "react";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router";

import Header, {
  NoHeaderScroll,
  BackHeaderLeft,
} from "../../components/navigation/header";
import axios from "../../services/axios";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function HeaderLeft() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/home");
  };

  return <BackHeaderLeft onClick={handleBack} />;
}

export default function Premium() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.isPremium) {
      navigate("/home");
    }
  }, [user]);

  const fetchClientSecret = useCallback(async () => {
    // Create a Checkout Session
    if (user?.id_usuario) {
      const { data } = await axios.post("payment/create-checkout-session", {
        id_usuario: user.id_usuario,
      });

      return data.clientSecret;
    } else {
      return null;
    }
  }, [user]);

  const options = { fetchClientSecret };

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={HeaderLeft} HeaderCenter={() => {}} />
      <NoHeaderScroll className="">
        <div id="checkout">
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>
      </NoHeaderScroll>
    </div>
  );
}
